import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import Logo from '../assets/images/Logo_blue_2x.svg';
import HomeIcon from '../components/svg/HomeIcon';
import CurrencyIcon from '../components/svg/CurrencyIcon';
import ClockCounterIcon from '../components/svg/ClockCounterIcon';
import RewardsIcon from '../components/svg/RewardsIcon';
import QuestionIcon from '../components/svg/QuestionIcon';
import BlockchainIcon from '../components/svg/BlockchainIcon';

import ArrowIcon from '../assets/images/arrowsInLineHorizontal.svg';

const SendIcon = ({ size = 'w-5 h-5', color = '#181D27' }) => (
  <svg className={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M22 2L11 13" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    <path d="M22 2L15 22L11 13L2 9L22 2Z" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

const sidebarData = [
  {
    title: 'Inicio',
    icon: (size, color) => <HomeIcon size={size} color={color} />,
    alt: 'Home Icon',
    path: '/dashboard',
  },
  {
    title: 'Transferir',
    icon: (size, color) => <SendIcon size={size} color={color} />,
    alt: 'Transfer Icon',
    path: '/dashboard/transfer',
  },
  {
    title: 'Cuentas',
    icon: (size, color) => <CurrencyIcon size={size} color={color} />,
    alt: 'Currency Icon',
    path: '/dashboard/accounts',
  },
  {
    title: 'Mis Activos',
    icon: (size, color) => <BlockchainIcon size={size} color={color} />,
    alt: 'Assets Icon',
    path: '/dashboard/assets',
  },
  {
    title: 'Historial',
    icon: (size, color) => <ClockCounterIcon size={size} color={color} />,
    alt: 'Clock Counter Icon',
    path: '/dashboard/history',
  },
  {
    title: 'Recompensas',
    icon: (size, color) => <RewardsIcon size={size} color={color} />,
    alt: 'Rewards Icon',
    path: '/dashboard/rewards',
  },
];

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();

  const [activeTab, setActiveTab] = useState('/');

  useEffect(() => {
    setActiveTab(location.pathname);
  }, [location.pathname]);

  const onChangeRoute = (path) => {
    setActiveTab(path);
    navigate(path);
  };

  return (
    <div className="w-65 h-screen bg-white border-r border-r-1 border-r-[#F5F5F5] p-6 flex flex-col justify-between">
      <div className="space-y-8">
        <div className="w-[155px] h-17">
          <img src={Logo} alt="App logo" />
        </div>
        <ul className="space-y-1">
          {sidebarData.map((data, idx) => (
            <li
              key={idx}
              onClick={() => onChangeRoute(data.path)}
              className={`px-4 py-3 w-52 rounded-[12px] cursor-pointer hover:bg-[#E6EBF7] flex items-center justify-center space-x-1 text-[#2A59C6] ${
                activeTab == data.path ? 'bg-[#E6EBF7]' : ''
              }`}
            >
              {data.icon('w-5 h-5', activeTab == data.path ? '#2A59C6' : '#181D27')}
              <p
                className={`w-full text-sm leading-[20px] tracking-[0%] ${
                  activeTab == data.path
                    ? 'text-[#2A59C6] font-semibold'
                    : 'text-[#181D27] font-normal'
                }`}
              >
                {data.title}
              </p>
            </li>
          ))}
        </ul>
      </div>

      <div className="border-t-1 border-t-[#D5D7DA]">
        <button
          onClick={() => onChangeRoute('/dashboard/contact')}
          className={`p-4 py-3 w-52 cursor-pointer hover:bg-[#E6EBF7] flex items-center justify-center space-x-1 ${
            activeTab == '/contact' ? 'bg-[#E6EBF7]' : ''
          }`}
        >
          <QuestionIcon color={activeTab == '/dashboard/contact' ? '#2A59C6' : '#181D27'} />
          <p
            className={`w-full text-sm font-normal leading-[20px] tracking-[0%] text-left ${
              activeTab == '/contact'
                ? 'text-[#2A59C6] font-semibold'
                : 'text-[#181D27] font-normal'
            }`}
          >
            Ayuda
          </p>
        </button>
        <button className="p-4 py-3 w-52 cursor-pointer hover:bg-[#E6EBF7] flex items-center justify-center space-x-1">
          <img src={ArrowIcon} alt="Arrow Icon" className="w-5 h-5" />
          <p className="w-full text-sm font-normal leading-[20px] tracking-[0%] text-[#181D27] text-left">
            Colapsar
          </p>
        </button>
      </div>
    </div>
  );
}
